import { Link } from "react-router-dom";
import { CheckCircle2, Circle, X } from "lucide-react";
import { useState } from "react";
import { useOnboarding } from "../../lib/onboarding";

const KEY = "aegis-checklist-dismissed";

export const OnboardingChecklist = () => {
  const { data } = useOnboarding();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  if (!data || hidden || (data.day > 7 && data.done === data.total)) return null;
  const pct = Math.round((100 * data.done) / data.total);
  return (
    <section className="panel mb-6 p-5 rise" data-testid="onboarding-checklist">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="label-xs text-brand">Setup checklist · day {Math.min(data.day, 7)} of 7</p>
          <h2 className="text-lg font-bold mt-1">{data.done === data.total ? "You're fully set up. AEGIS is defending every sale." : "Let's get your defense live"}</h2>
        </div>
        <div className="flex items-center gap-4">
          <span className="font-mono text-2xl font-extrabold text-brand" data-testid="onboarding-progress">{data.done}/{data.total}</span>
          <button onClick={() => { localStorage.setItem(KEY, "1"); setHidden(true); }} className="text-white/35 hover:text-white transition-colors" title="Hide checklist" data-testid="onboarding-dismiss-btn"><X className="w-4 h-4" /></button>
        </div>
      </div>
      <div className="h-1 bg-white/5 mt-4"><div className="h-full bg-brand transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
      <ol className="grid md:grid-cols-5 gap-3 mt-4">
        {data.steps.map((s, i) => (
          <li key={s.id} data-testid={`onboarding-step-${s.id}`}>
            <Link to={s.to} className={`block h-full p-3 border transition-colors ${s.done ? "border-brand/30 bg-brand/[0.04]" : "border-white/10 hover:border-white/30"}`}>
              <p className="flex items-center gap-2 text-sm">{s.done ? <CheckCircle2 className="w-4 h-4 text-brand shrink-0" /> : <Circle className="w-4 h-4 text-[#FFB800] shrink-0" />}<span className="font-mono text-[10px] text-white/40">0{i + 1}</span></p>
              <p className="text-sm mt-2">{s.title}</p>
              <p className="text-[11px] text-white/45 mt-1">{s.note}</p>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
};
